import { clsx } from 'clsx';
import { useMemo } from 'react';
import {
  eventColors,
  eventColorsDark,
  eventStateLabel,
  eventStatusContent,
  eventStatusWrapper,
} from 'src/components/Events/EventStatus/EventStatus.css';
import { Content } from 'src/contexts/ContentContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { EVENT_STATUS_TO_CID } from 'src/utils/constants/contentIdMaps';
import { ApiEventStatus } from 'src/WebApiController';

import { EventStatusProps, EventStatusToColor } from './EventStatus.type';

export const EventStatus = ({ status }: EventStatusProps) => {
  const { isDarkMode } = useSiteTheme();

  const eventColorClassname = useMemo(() => {
    if (!status) {
      return undefined;
    }
    if (isDarkMode) {
      return eventColorsDark[EventStatusToColor[status]];
    }
    return eventColors[EventStatusToColor[status]];
  }, [isDarkMode, status]);

  // Don't show normal state
  if (!status || status === ApiEventStatus.Normal) {
    return null;
  }

  return (
    <div className={eventStatusWrapper}>
      <div className={clsx(eventStatusContent, eventColorClassname)}>
        <span className={eventStateLabel}>
          <Content id={EVENT_STATUS_TO_CID[status]} />
        </span>
      </div>
    </div>
  );
};
